import { ActionExtended } from "src/_common/interfaces/ActionExtended";
import { ACTIONS } from "src/_config";
export interface EventReducer {
  getEventList: unknown;
  getEventGameList: Array<Record<string, unknown>> | null;
  getEventGameDetails: Record<string, unknown> | null;
  getEventStatusMessage: Array<Record<string, unknown>> | null;
  getIrStatusMessage: unknown;
  getLeaderBoard: unknown;
  getTvImageDetails: unknown;
  getWiningTruckDetails: unknown;
  winingTruckModalShow: boolean;
  fromRoute: unknown;
  pick_id: number[] | null;
  login_required: number;
  site_header: unknown;
  gameDetails: unknown;
  rodeoEventSettings: unknown;
  performanceList: unknown;
  taskList: unknown;
}

const initialState: EventReducer = {
  getEventList: null,
  getEventGameList: null,
  getEventGameDetails: null,
  getEventStatusMessage: null,
  getIrStatusMessage: null,
  getLeaderBoard: null,
  getTvImageDetails: null,
  getWiningTruckDetails: null,
  winingTruckModalShow: false,
  fromRoute: null,
  pick_id: null,
  login_required: 0,
  site_header: null,
  gameDetails: null,
  rodeoEventSettings: null,
  performanceList: null,
  taskList: null,
};

const eventReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    case ACTIONS.EVENT.GET_EVENT_LIST:
      return {
        ...state,
        getEventList: action.payload,
      };
    case ACTIONS.EVENT.GET_EVENT_GAME:
      return {
        ...state,
        getEventGameList: action.payload,
      };
    case ACTIONS.EVENT.GET_EVENT_GAME_DETAILS:
      return {
        ...state,
        getEventGameDetails: action.payload,
      };
    case ACTIONS.EVENT.GET_STATUS_MESSAGE:
      return {
        ...state,
        getEventStatusMessage: action.payload,
      };
    case ACTIONS.EVENT.LEADERBOARD:
      return {
        ...state,
        getLeaderBoard: action.payload,
      };
    case ACTIONS.TV_IMAGE.DETAILS:
      return {
        ...state,
        getTvImageDetails: action.payload,
      };
    case ACTIONS.EVENT.OPEN_WINING_MODAL:
      return {
        ...state,
        winingTruckModalShow: action.payload,
      };
    case ACTIONS.EVENT.NEXT_EVENT_FROM_ROUTE:
      return {
        ...state,
        fromRoute: action.payload,
      };
    case ACTIONS.EVENT.SET_PICK_ID: {
      const pickId = state.pick_id ? [...state.pick_id, action.payload] : [action.payload];
      // console.log(pickId)
      return {
        ...state,
        pick_id: pickId,
      };
    }
    case ACTIONS.EVENT.RESET_PICK_ID:
      return {
        ...state,
        pick_id: null,
      };
    case ACTIONS.EVENT.RODEO_EVENT_LOGIN_REQUIRED:
      return {
        ...state,
        login_required: action.payload,
      };
    case ACTIONS.EVENT.SITE_HEADER:
      return {
        ...state,
        site_header: action.payload,
      };

    //Update rider vote details
    case ACTIONS.EVENT.GET_SOCKET_RIDER_WITH_VOTE_DETAILS: {
      const socketData = (action.payload as { socketData?: Record<string, unknown> })?.socketData as
        | (Record<string, unknown> & { rodeo_event_event_id?: number; riders?: unknown })
        | undefined;
      const gameDetailsForRider = state.getEventGameDetails as
        | (Record<string, unknown> & { events?: { id?: number; riders?: unknown } })
        | null;
      if (gameDetailsForRider?.events && socketData && gameDetailsForRider.events.id === socketData.rodeo_event_event_id) {
        gameDetailsForRider.events.riders = socketData.riders;
      }

      return {
        ...state,
        getEventGameDetails: {
          ...gameDetailsForRider,
        },
      };
    }

    // Update Game Status at Event game list page
    case ACTIONS.EVENT.GET_SOCKET_START_DATA_AND_PUSH_TO_GAME_LIST: {
      const socketData = (action.payload as { socketData?: Record<string, unknown> })?.socketData as
        | (Record<string, unknown> & { id?: number; status?: unknown })
        | undefined;
      const eventList = state.getEventGameList as Array<Record<string, unknown> & { id?: number; status?: unknown }> | null;
      if (eventList && eventList.length && socketData) {
        const findGameIndex = eventList.findIndex((x) => x.id === socketData.id);
        if (findGameIndex >= 0) {
          eventList[findGameIndex].status = socketData.status;
        }
      }

      return {
        ...state,
        getEventGameList: eventList && eventList.length ? eventList.map((x) => Object.assign(x)) : [],
      };
    }

    //Update game event details data
    case ACTIONS.EVENT.GET_SOCKET_START_DATA_AND_PUSH_TO_GAME_DETAILS: {
      const socketData = (action.payload as { socketData?: Record<string, unknown> })?.socketData as
        | (Record<string, unknown> & { id?: number; status?: unknown })
        | undefined;
      const gameDetails = state.getEventGameDetails as
        | (Record<string, unknown> & { events?: { id?: number; status?: unknown } })
        | null;
      if (gameDetails?.events && socketData && gameDetails.events.id == socketData.id) {
        gameDetails.events.status = socketData.status;
      }
      return {
        ...state,
        getEventGameDetails: {
          ...gameDetails,
        },
      };
    }

    //Update game status message
    case ACTIONS.EVENT.GET_SOCKET_STATUS_MESSAGE_AND_PUSH_TO_STATUS_LIST: {
      const socketData = (action.payload as { socketData?: Record<string, unknown> })?.socketData as
        | (Record<string, unknown> & { rodeo_event_id?: number; status_text?: string })
        | undefined;
      const statusMessageList = (state.getEventStatusMessage || []) as Array<
        Record<string, unknown> & { rodeo_event_id?: number; status_text?: string }
      >;
      if (socketData && statusMessageList.length) {
        statusMessageList.forEach((x, index) => {
          if (x.rodeo_event_id === socketData.rodeo_event_id) {
            statusMessageList[index].status_text = socketData.status_text;
          }
        });
      } else if (socketData) {
        statusMessageList.push(socketData);
      }
      return {
        ...state,
        getEventStatusMessage:
          statusMessageList.length ? statusMessageList.map((x) => Object.assign(x)) : [],
      };
    }

    case ACTIONS.EVENT.GET_IR_STATUS_MESSAGE: {
      const y = action.payload ? (action.payload as { status_text?: unknown }).status_text : null;
      return {
        ...state,
        getIrStatusMessage: y,
      };
    }

    //Update wining truck details
    case ACTIONS.EVENT.GET_WINING_SOCKET_DATA_AND_PUSH_TO_WINING_DETAILS: {
      const socketData = (action.payload as { socketData?: Record<string, unknown> })?.socketData as
        | (Record<string, unknown> & {
            event_dtls?: Record<string, unknown> & { id?: number; rodeo_event_id?: number; status?: number; isjoined?: boolean };
            truck?: { id?: number };
          })
        | undefined;
      const gameDetailsPage = state.getEventGameDetails as
        | (Record<string, unknown> & {
            event_dtls?: Record<string, unknown> & { id?: number; status?: number; isjoined?: boolean; winning?: Record<string, unknown> };
          })
        | null;
      let winingData: Record<string, unknown> | null = null;
      let isWiningModalShow = false;
      if (socketData && socketData.event_dtls) {
        // If socket data && inside data event details exist
        if (gameDetailsPage && gameDetailsPage.event_dtls && gameDetailsPage.event_dtls.isjoined) {
          // If current user joined that game
          if (
            gameDetailsPage &&
            gameDetailsPage.event_dtls &&
            gameDetailsPage.event_dtls.id === socketData.event_dtls.id
          ) {
            //if socket game id equals to user stay on page game id
            if (gameDetailsPage.event_dtls.status === 2 && socketData.event_dtls.status === 2) {
              // if game status is end, 0 => Not started, 1=> Ongoing, 2=> End
              winingData = socketData;
              isWiningModalShow = true;
              gameDetailsPage.event_dtls.winning = {
                //Update Wining Reducer data
                event_id: socketData.event_dtls.id,
                rodeo_event_id: socketData.event_dtls.rodeo_event_id,
                truck_id: socketData.truck?.id ?? 0,
              };
            }
          }
        } else {
          if (gameDetailsPage && gameDetailsPage.event_dtls && !gameDetailsPage.event_dtls.isjoined) {
            // If current user not joined that game
            if (
              gameDetailsPage &&
              gameDetailsPage.event_dtls &&
              gameDetailsPage.event_dtls.id === socketData.event_dtls.id
            ) {
              //if socket game id equals to user stay on page game id
              if (gameDetailsPage.event_dtls.status === 2 && socketData.event_dtls.status === 2) {
                // if game status is end, 0 => Not started, 1=> Ongoing, 2=> End
                gameDetailsPage.event_dtls.winning = {
                  //Update Wining Reducer data
                  event_id: socketData.event_dtls.id,
                  rodeo_event_id: socketData.event_dtls.rodeo_event_id,
                  truck_id: socketData.truck?.id ?? 0,
                };
              }
            }
          }
        }
      }
      return {
        ...state,
        getWiningTruckDetails: winingData ? { ...winingData } : null,
        winingTruckModalShow: isWiningModalShow ? isWiningModalShow : false,
        getEventGameDetails: {
          ...gameDetailsPage,
        },
      };
    }

    case ACTIONS.EVENT.GET_EVENT_LIST_GLOWING_SOCKET: {
      const socketData = (action.payload as { socketData?: Record<string, unknown> })?.socketData as
        | (Record<string, unknown> & { settings?: { rodeo_event_id?: number; is_event_glow?: unknown } })
        | undefined;
      const getEventListData = (state.getEventList as { list?: Array<Record<string, unknown> & { id?: number; rodeo_event_game_info?: { is_event_glow?: unknown } }> })?.list;
      if (socketData && getEventListData && getEventListData.length) {
        const findEventIndex = getEventListData.findIndex((x) => x.id == socketData.settings?.rodeo_event_id);
        console.log({ findEventIndex, socketData });
        const eventItem = getEventListData[findEventIndex];
        if (findEventIndex >= 0 && eventItem?.rodeo_event_game_info) {
          // eventItem.currently_ongoing = socketData.check_ongoing_event
          eventItem.rodeo_event_game_info.is_event_glow = socketData.settings?.is_event_glow;
        }
      }
      return {
        ...state,
        getEventList: {
          ...(state.getEventList as Record<string, unknown>),
          list: getEventListData && getEventListData.length ? getEventListData.map((x) => Object.assign(x)) : [],
        },
      };
    }
    case ACTIONS.EVENT.GET_GAME_DETAILS:
      return {
        ...state,
        gameDetails: action.payload,
      };

    case ACTIONS.EVENT.RODEO_EVENT_SETTINGS:
      return {
        ...state,
        rodeoEventSettings: action.payload,
      };

    case ACTIONS.EVENT.SET_EVENT_IS_PICKED: {
      const event_id = (action.payload as { event_id?: number })?.event_id;
      // let performance_id=action.payload.performance_id
      // let rodeo_event_id=action.payload.rodeo_event_id
      const eventGameList = state.getEventGameList as Array<Record<string, unknown> & { id?: number; ispicked?: unknown }> | null;
      // console.log("1",eventGameList,action.payload)
      if (eventGameList && eventGameList.length) {
        const findGameIndex = eventGameList.findIndex((x) => {
          // console.log({x},x.id, event_id, x.id == event_id)
          return x.id == event_id;
        });
        // console.log("2", findGameIndex)
        if (findGameIndex >= 0) {
          // console.log("3", findGameIndex, action.payload)
          eventGameList[findGameIndex].ispicked = action.payload;
        }
      }

      return {
        ...state,
        getEventGameList: eventGameList,
      };
    }

    case ACTIONS.EVENT.PERFORMANCE_LIST:
      return {
        ...state,
        performanceList: action.payload,
      };

    case ACTIONS.EVENT.UPDATE_TASK_LIST_SCAN_COUNT: {
      const currentTask = action.payload as Record<string, unknown> & { id?: number };
      const tasks = (state.getEventGameList || []).map((t) => {
        const task = t as Record<string, unknown> & { id?: number; scan_user_count?: number };
        if (task.id == currentTask.id) {
          task["scan_user_count"] = (task["scan_user_count"] ? Number(task["scan_user_count"]) : 0) + 1;
        }
        console.log({ t: task });
        return task;
      });
      return {
        ...state,
        getEventGameList: tasks,
      };
    }

    case ACTIONS.EVENT.UPDATE_TASK_LIST_SCAN_START: {
      const curTask = action.payload as Record<string, unknown> & { id?: number; scan_start?: unknown };
      const taskList = (state.getEventGameList || []).map((t) => {
        const task = t as Record<string, unknown> & { id?: number; scan_start?: unknown };
        if (task.id == curTask.id) {
          task["scan_start"] = curTask["scan_start"];
        }
        // console.log({ t });
        return task;
      });
      return {
        ...state,
        getEventGameList: taskList,
      };
    }

    default:
      return state;
  }
};

export default eventReducer;
